import React from "react";
import CarouselWithCards, {
  CarouselProps,
} from "@/components/CarouselWithCards/CarouselWithCards";
import { ContactCarouselContainer, Heading, Paragraph, TextContainer } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

export type LocationsType = {
  locations: CarouselProps["cards"];
};

const ContactCarousel: React.FC<LocationsType> = (props) => {
  const { locations } = props;
  const { locale = "it" } = useRouter();
  const t = {
    locationsTitle: useTranslation("ContactPage.locationsTitle", locale) || "",
    locationsSubTitle:
      useTranslation("ContactPage.locationsSubTitle", locale) || "",
  };

  return (
    <ContactCarouselContainer>
      <TextContainer>
        <Heading>{t.locationsTitle}</Heading>
        <Paragraph>{t.locationsSubTitle}</Paragraph>
      </TextContainer>
      <CarouselWithCards cards={locations} />
    </ContactCarouselContainer>
  );
};

export default ContactCarousel;
